export default __webpack_public_path__ + "static/media/13t.49007c3a.jpg";